import { extendTheme } from '@chakra-ui/react';

export default extendTheme({
  config: {
    initialColorMode: 'dark',
  },
  colors: {
    brand: {
      50: '#ceb0b1',
      100: '#ba9194',
      200: '#a57277',
      300: '#8c5960',
      400: '#6d454c',
      500: '#4f3137',
      secondary: '#4f3137',
      700: '#170708',
      800: '#170708',
      900: '#170708',
    },
  },
  components: {
    Container: {
      defaultProps: {
        // color: '#262626',
        color: 'red',
      },
    },
    Input: {
      defaultProps: {
        variant: 'filled',
      },
    },
    Button: {
      baseStyle: {
        border: '1px solid black',
        color: 'gold',
      },
      // defaultProps: {
      //   // colorScheme: "brand",
      //   // color:'white',
      //   // bg: 'red'
      // },
      variants: {
        // Default
        solid() {
          return {
            bg: 'brand.500',
            _hover: {
              bg: `brand.500`,
            },
            _active: { bg: `brand.500` },
          }
        },
        important() {
          return {
            color: 'white',
            bg: 'red',
            _hover: {
              bg: `red`,
            },
            _active: { bg: `red` },
          }
        },
        secondary() {
          return {
            color: 'white',
            bg: 'brand.secondary',
            _hover: {
              bg: `brand.secondary`,
            },
            _active: { bg: `brand.secondary` },
          }
        },
      },
    },
    Heading: {
      baseStyle: {
        marginBottom: '0.5em',
      },
    },
  },
});
